export default __webpack_public_path__ + "static/media/basic.f07799e0.png";